mutation DeleteEmailTemplates($ids: [ID!]!) {
  deleteEmailTemplates(ids: $ids) {
    id
  }
}
